// convertDocDefinitionToHTMLManaswini.js - MATCHES PREVIEW EXACTLY
export const convertDocDefinitionToHTMLManaswini = (docDefinition, totalPages = 0) => {
const { content = [] } = docDefinition;
const pageMargins = [40, 20, 40, 70]; // your custom margins for HTML only
  const headerContent =
    typeof docDefinition.header === "function"
      ? docDefinition.header(1, 1)
      : docDefinition.header;

  const footerContent =
    typeof docDefinition.footer === "function"
      ? docDefinition.footer(1, 1)
      : docDefinition.footer;

  const escapeHtml = (text) => {
    if (typeof text !== "string") return String(text || "");
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  const getTextContent = (node) => {
    if (typeof node === "string") return node;
    if (node && typeof node === "object") {
      if (node.text !== undefined) {
        if (typeof node.text === "string") return node.text;
        if (typeof node.text === "object" && node.text !== null && node.text.text !== undefined)
          return String(node.text.text ?? "");
        return String(node.text ?? "");
      }
    }
    return String(node || "");
  };

  let processNode;
  processNode = (node) => {
    if (!node) return "";
    if (Array.isArray(node)) return node.map(processNode).join("");

    if (node.canvas) {
      const shape = node.canvas[0];
      if (!shape) return "";
      if (shape.type === "rect") {
        return `<div style="height:${shape.h || 5}px;background:${shape.color || "#990000"};margin-left:-${pageMargins[0]}px;margin-right:-${pageMargins[2]}px;width:calc(100% + ${pageMargins[0] + pageMargins[2]}px);"></div>`;
      }
      // line
      const color = shape.lineColor || "#000";
      const lw = shape.lineWidth || 0.5;
      return `<hr style="border:none;border-top:${lw}px solid ${color};margin:4px 0;" />`;
    }

    if (node.image) {
      let src = "";
      if (typeof node.image === "string")
        src = node.image.startsWith("data:") ? node.image : `data:image/png;base64,${node.image}`;
      const width = node.width || 60;
      const alignment = node.alignment || "left";
      const mt = node.margin ? (Array.isArray(node.margin) ? node.margin[1] || 0 : 0) : 0;
      let style = `display:block;margin-top:${mt}px;width:${width}px;`;
      if (alignment === "center") style += "margin-left:auto;margin-right:auto;";
      else if (alignment === "right") style += "margin-left:auto;";
      return `<img src="${src}" style="${style}" />`;
    }

    if (node.stack) {
      const m = node.margin;
      const ms = Array.isArray(m)
        ? `margin:${m[1] || 0}px ${m[2] || 0}px ${m[3] || 0}px ${m[0] || 0}px;`
        : "";
      return `<div style="${ms}">${node.stack.map(processNode).join("")}</div>`;
    }

    if (node.columns) {
      const m = node.margin;
      const ms = Array.isArray(m)
        ? `margin:${m[1] || 0}px 0 ${m[3] || 0}px 0;`
        : "margin-bottom:2px;";
      const colEls = node.columns.map((col) => {
        if (!col) return "";
        let flex = "flex:1;";
        if (col.width === "*") flex = "flex:1;";
        else if (typeof col.width === "string" && col.width.endsWith("%"))
          flex = `flex:0 0 ${col.width};width:${col.width};`;
        else if (typeof col.width === "number")
          flex = `flex:0 0 ${col.width}px;max-width:${col.width}px;`;
        const align =
          col.alignment === "right" ? "text-align:right;" :
          col.alignment === "center" ? "text-align:center;" :
          col.alignment === "left" ? "text-align:left;" : "";
        const inner = col.stack ? col.stack.map(processNode).join("") : processNode(col);
        return `<div style="${flex}${align}min-width:0;">${inner}</div>`;
      });
      return `<div style="display:flex;flex-wrap:nowrap;align-items:flex-start;${ms}">${colEls.join("")}</div>`;
    }

    if (node.table) {
      const { body = [], headerRows = 0, widths = [] } = node.table;
      const m = node.margin;
      const ms = Array.isArray(m)
        ? `margin:${m[1] || 0}px 0 ${m[3] || 6}px 0;`
        : "margin:2px 0 6px 0;";
      let t = `<table style="width:100%;border-collapse:collapse;${ms}">`;
      if (widths.length > 0) {
        t += "<colgroup>";
        widths.forEach((w) => {
          const wStr = typeof w === "number" ? `${w}px` : w;
          t += `<col style="width:${wStr}">`;
        });
        t += "</colgroup>";
      }
      body.forEach((row, ri) => {
        const isHdr = ri < headerRows;
        t += "<tr>";
        row.forEach((cell) => {
          const tag = isHdr ? "th" : "td";
          let cellHtml = "";
          let st = "padding:4px;vertical-align:top;font-size:9pt;border:0.75px solid #000;";
          let cs = "";
          if (typeof cell === "string") {
            cellHtml = escapeHtml(cell);
          } else if (cell && typeof cell === "object") {
            if (cell.stack) {
              cellHtml = cell.stack.map(processNode).join("");
            } else if (cell.columns) {
              cellHtml = processNode(cell);
            } else {
              cellHtml = escapeHtml(getTextContent(cell));
              if (cell.bold) st += "font-weight:bold;";
              if (cell.fontSize) st += `font-size:${cell.fontSize}pt;`;
              if (cell.color) st += `color:${cell.color};`;
              if (cell.alignment) st += `text-align:${cell.alignment};`;
              if (cell.italics) st += "font-style:italic;";
            }
            if (cell.colSpan && cell.colSpan > 1) cs = ` colspan="${cell.colSpan}"`;
          }
          t += `<${tag}${cs} style="${st}">${cellHtml}</${tag}>`;
        });
        t += "</tr>";
      });
      t += "</table>";
      return t;
    }

    if (node.text !== undefined) {
      const text = escapeHtml(getTextContent(node));
      const fs = node.fontSize ? `font-size:${node.fontSize}pt;` : "font-size:9pt;";
      const fw = node.bold ? "font-weight:bold;" : "";
      const fi = node.italics ? "font-style:italic;" : "";
      const fc = node.color ? `color:${node.color};` : "";
      const fa = node.alignment ? `text-align:${node.alignment};` : "";
      const fd = node.decoration === "underline" ? "text-decoration:underline;" : "";
      const m = node.margin;
      const ms = Array.isArray(m)
        ? `margin:${m[1] || 0}px 0 ${m[3] || 0}px 0;`
        : "";
      return `<div style="${fs}${fw}${fi}${fc}${fa}${fd}${ms}">${text}</div>\n`;
    }

    return "";
  };

  // ── Build the HEADER HTML exactly like pdfmake renders it ──
  // Structure from docdeflabreportprint.js header():
  //   columns: [ logo | hospital name stack | spacer ]
  //   red line (1.8px)
  //   patient info table
  //   black thin line (0.5px)
  const buildHospitalHeaderHtml = () => {
    if (!headerContent) return "";

    // Extract the stack items from header
    const stack = headerContent.stack || [];

    // Item 0: columns (logo + name + spacer)
    // Item 1: canvas (red line)
    // Item 2: patient info table
    // Item 3: canvas (thin black line)

    let logoHtml = "";
    let nameStackHtml = "";
    let redLineHtml = "";
    let patientTableHtml = "";
    let thinLineHtml = "";

    stack.forEach((item, i) => {
      if (i === 0 && item.columns) {
        // logo column
        const logoCol = item.columns[0];
        const nameCol = item.columns[1];

        if (logoCol?.image) {
          const src = logoCol.image.startsWith("data:") ? logoCol.image : `data:image/png;base64,${logoCol.image}`;
          logoHtml = `<img src="${src}" style="width:55px;margin-right:8px;margin-top:4px;" />`;
        }

        if (nameCol?.stack) {
          nameStackHtml = `<div style="flex:1;">` + nameCol.stack.map(processNode).join("") + `</div>`;
        }
      } else if (i === 1 && item.canvas) {
        const shape = item.canvas[0];
        const lw = shape?.lineWidth || 1.8;
        const color = shape?.lineColor || "#990000";
        redLineHtml = `<hr style="border:none;border-top:${lw}px solid ${color};margin:6px 0 10px 0;" />`;
      } else if (i === 2 && item.table) {
        patientTableHtml = processNode(item);
      } else if (i === 3 && item.canvas) {
        const shape = item.canvas[0];
        const lw = shape?.lineWidth || 0.5;
        const color = shape?.lineColor || "#000000";
        thinLineHtml = `<hr style="border:none;border-top:${lw}px solid ${color};margin:6px 0 4px 0;" />`;
      }
    });

    return `
      <div style="display:flex;flex-direction:row;align-items:flex-start;margin-bottom:2px;">
        ${logoHtml}
        ${nameStackHtml}
        <div style="width:55px;"></div>
      </div>
      ${redLineHtml}
      ${patientTableHtml}
      ${thinLineHtml}
    `;
  };

  const hospitalHeaderHtml = buildHospitalHeaderHtml();

  // ── Build footer HTML ──
  const buildFooterHtml = () => {
    if (!footerContent) return "";

    const stack = footerContent.stack || [];
    let html = "";

    stack.forEach((item) => {
      // skip "Page N of N" text — CSS @page handles it
      if (item.text !== undefined) {
        const raw = typeof item.text === "string" ? item.text : String(item.text ?? "");
        if (/^\s*page\s+\d+\s+of\s+\d+\s*$/i.test(raw)) return;
      }
      // skip the red rect canvas — we'll render it as a full-width bar at very bottom
      if (item.canvas) {
        const shape = item.canvas[0];
        if (shape?.type === "rect" && shape?.color) return; // skip, rendered separately
      }
      html += processNode(item);
    });

    return html;
  };

  const footerHtml = buildFooterHtml();

  // ── Body content (skipping index 0 which is the columnHeader node) ──
  // columnHeader is already in content[0] from docdeflabreportprint.js
  // We render it with a bottom border line to match preview
  const bodyHtml = content.map((item, idx) => {
    // The first item is the column header (TEST PARAMETER / RESULT / REFERENCE RANGE)
    if (idx === 0) {
      // Render it specially with a bottom border line like preview
      if (item.columns) {
        const cols = item.columns.map((col) => {
          let flex = "flex:1;";
          if (typeof col.width === "string" && col.width.endsWith("%"))
            flex = `flex:0 0 ${col.width};width:${col.width};`;
          const text = escapeHtml(getTextContent(col));
          return `<div style="${flex}font-size:9pt;font-weight:bold;">${text}</div>`;
        });
        return `
          <div style="display:flex;flex-wrap:nowrap;padding:4px 0 4px 0;border-bottom:0.75px solid #000;margin-bottom:4px;">
            ${cols.join("")}
          </div>`;
      }
    }
    return `<div class="content-chunk">${processNode(item)}</div>`;
  }).join("");

  return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
* { box-sizing:border-box; margin:0; padding:0; }

@page {
  size: A4;
  margin-top: ${pageMargins[1]}px;
  margin-right: ${pageMargins[2]}px;
  margin-bottom: ${pageMargins[3]}px;
  margin-left: ${pageMargins[0]}px;

  @bottom-center {
    content: "Page " counter(page) " of " counter(pages);
    font-family: Arial, sans-serif;
    font-size: 8pt;
    color: #000;
  }
}

body {
  font-family: Arial, sans-serif;
  font-size: 9pt;
  line-height: 1.4;
  color: #000;
  background: white;
  margin: 0;
  padding: 0;
}

.outer-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.outer-table > thead > tr > td,
.outer-table > tfoot > tr > td,
.outer-table > tbody > tr > td {
  padding: 0;
  border: none;
  width: 100%;
  display: block;
}

.content-chunk {
  width: 100%;
}

@media print {
  body { margin:0; padding:0; }
  .no-print { display:none; }
}

@media screen {
  body { padding:20px; background:#f0f0f0; }
  .screen-wrap {
    background:white;
    padding:20px ${pageMargins[2]}px ${pageMargins[3]}px ${pageMargins[0]}px;
    max-width:794px;
    margin:0 auto;
    box-shadow:0 2px 8px rgba(0,0,0,0.15);
  }
}

hr { border:none; border-top:1px solid #000; margin:4px 0; }
</style>
</head>
<body>
<div class="screen-wrap">

<table class="outer-table">

  <thead>
    <tr>
      <td>
        <div style="padding-bottom:4px;">
          ${hospitalHeaderHtml}
        </div>
      </td>
    </tr>
  </thead>

  <tfoot>
    <tr>
      <td>
        <div style="padding-top:6px;">
          ${footerHtml}
        </div>
        <!-- Red bar at very bottom, full width -->
        <div style="height:5px;background:#990000;margin-left:-${pageMargins[0]}px;margin-right:-${pageMargins[2]}px;"></div>
      </td>
    </tr>
  </tfoot>

  <tbody>
    <tr>
      <td>
        <div class="content-chunk" style="padding-top:6px;">
          ${bodyHtml}
        </div>
      </td>
    </tr>
  </tbody>

</table>

</div>
</body>
</html>`;
};